import axios from "axios";
import { attachJweInterceptors } from "../crypto/jweInterceptor";
import store from "../store";
import { clearUserData } from "../store/userSlice";
import { isSessionSyncInProgress } from "./sessionSyncGuard";

const API_URL = process.env.REACT_APP_API_URL;

const axiosInstance = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

function isAuthFailure(error) {
  const status = error?.response?.status;
  if (status === 401) return true;
  const body = error?.response?.data;
  const msg = body?.error || body?.message || "";
  return (
    status === 500 &&
    /auth middleware failed|session expired|invalid token|no token/i.test(
      String(msg)
    )
  );
}

// Paths that are publicly accessible — auth failures here should not trigger
// a redirect to login (e.g. the affiliate registration page).
const PUBLIC_PATHS = ["/", "/register"];

function isPublicPath() {
  return PUBLIC_PATHS.some(
    (p) =>
      window.location.pathname === p ||
      window.location.pathname.startsWith(`${p}/`)
  );
}

function handleAuthFailure() {
  if (isSessionSyncInProgress()) {
    return;
  }
  store.dispatch(clearUserData());
  if (!isPublicPath()) {
    window.location.replace("/");
  }
}

attachJweInterceptors(axiosInstance);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const url = error?.config?.url || "";
    const isLogout =
      url.includes("/api/auth/logout") || url.includes("/auth/logout");
    if (!isLogout && isAuthFailure(error)) {
      handleAuthFailure();
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
